"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventSenderStats2NonAuth = void 0;
/**
 * A builder for EventSenderStats2NonAuth
 *
 * @param data - The event data
 * @return The formatted event data for EventSenderStats2NonAuthEvent
 */
function createEventSenderStats2NonAuth(data) {
    return {
        name: 'EventSenderStats2NonAuth',
        environments: ['devicenonauth', 'browsernonauth', 'desktopnonauth'],
        data: data,
    };
}
exports.createEventSenderStats2NonAuth = createEventSenderStats2NonAuth;
//# sourceMappingURL=createEventSenderStats2NonAuth.js.map